const DiffYear = (dateFrom, dateTo) => {
    return dateTo.getFullYear() - dateFrom.getFullYear() 
}
export default DiffYear